import { RoleResources } from '..'

import appraisal from './appraisal'

export const appraiser: RoleResources = {
  appraiser_appraisals: appraisal,
}
